module.exports = __webpack_public_path__ + "static/media/DDrive.6f48ee73.png";